import { Phone, Clock, Video } from "lucide-react";
import { TIERS } from "@/lib/links";
import { stepTone } from "@/components/booking/bookingHelpers";

const ICONS = { "30-min": Phone, "1-hour": Clock, "90-min": Video };
export const STEPS = ["Session", "Date & time", "Your details"];

export function BookingStepper({ step }) {
  return (
    <ol className="flex items-center gap-2 mb-8 text-xs font-mono uppercase tracking-widest" data-testid="booking-steps">
      {STEPS.map((s, i) => (
        <li key={s} className={`flex items-center gap-2 ${stepTone(i, step)}`}>
          <span className={`w-6 h-6 rounded-full grid place-items-center border ${i <= step ? "border-cyan-400" : "border-slate-700"}`}>{i + 1}</span>{s}
          {i < STEPS.length - 1 && <span className="w-6 h-px bg-slate-700" />}
        </li>
      ))}
    </ol>
  );
}

export function TierPicker({ value, onChange }) {
  return (
    <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-3" data-testid="step-service">
      {TIERS.map((t) => {
        const Icon = ICONS[t.id];
        return (
          <button key={t.id} type="button" onClick={() => onChange(t)} data-testid={`tier-${t.id}`}
            className={`text-left rounded-xl border p-5 transition-colors ${value?.id === t.id ? "border-cyan-500 bg-cyan-500/10" : "border-slate-800 bg-slate-900/40 hover:border-cyan-400/60"}`}>
            <Icon className="w-5 h-5 text-cyan-400" />
            <div className="font-display text-lg font-semibold mt-3">{t.title}</div>
            <div className="text-2xl font-extrabold text-cyan-400 font-display">${t.price}</div>
            <div className="text-xs text-slate-400 mt-2">{t.short}</div>
          </button>
        );
      })}
    </div>
  );
}

export function BookingSummary({ tier, slot, member, memberPrice }) {
  return (
    <div className="text-sm text-slate-400" data-testid="booking-summary">
      {tier && (
        <span>
          {tier.title} · ${member ? memberPrice : tier.price}
          {member && !member.included && <span className="text-[#FFD600]"> member price</span>}
          {member?.included && <span className="text-[#FFD600]"> included</span>}
        </span>
      )}
      {slot && <span> · {slot.label} Pacific</span>}
    </div>
  );
}
